import React from 'react'
import TabsProvider from '../tabs-provider'
import { CardTitle } from 'material-ui/Card'

const customStyles = {
  tab: {
    backgroundColor: 'white',
    color: 'rgba(37, 44, 171, 0.87)' // blue
  },
  tabs: {
    backgroundColor: 'white',
    borderBottom: 'rgba(0, 0, 0, 0.38)'
  },
  container: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.38)' // grey
  },
  inkBarStyle: {
    borderBottom: '2px solid #252CAB',
    color: 'rgba(37, 44, 171, 0.87)', // blue
    backgroundColor: 'none'
  }
}

const ImportDataTypes = ({ location, children }) => (
  <div>
    <CardTitle title='Member Data' style={{ paddingLeft: 0 }} />
    <TabsProvider
      styles={customStyles}
      pathname={location.pathname}
      tabs={[
        {
          label: 'Import Member Data',
          path: '/security/member-import'
        },
        {
          label: 'Log History',
          path: '/security/log-history'
        }
      ]}
    />
    {children}
  </div>
)

export default ImportDataTypes
